import { http } from "@shared/api/http";
import {
  UserResponse,
} from "./types";

export const getUser = async (
  id: string,
): Promise<UserResponse> => {
  const response = await http.get<UserResponse>(
    `/landing/profile/${id}/invite`,
  );

  return response.data;
};
